var _defs, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "box",
    width: 35.048,
    height: 35.048,
    viewBox: "0 0 35.048 35.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.55,
    x2: -0.548,
    y1: 1.69,
    y2: 1.687,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebebf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebebf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f9f2f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e8ebf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dde5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d6e2f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d4e1f4"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#a4c2f7}.cls-4{fill:#cad9fc}.cls-7{fill:#fff}.cls-8{fill:#428dff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13691",
    "data-name": "Group 13691",
    transform: "translate(.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16967",
    d: "M16.066 34.133h32.712v30.959a1.168 1.168 0 0 1-1.168 1.168H17.234a1.168 1.168 0 0 1-1.168-1.168V34.133z",
    className: "cls-1",
    "data-name": "Path 16967",
    transform: "translate(-15.482 -31.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16968",
    fill: "#e8edfc",
    d: "M16.066 34.133h30.959v30.959a1.168 1.168 0 0 1-1.168 1.168H17.234a1.168 1.168 0 0 1-1.168-1.168V34.133z",
    "data-name": "Path 16968",
    transform: "translate(-15.482 -31.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16969",
    d: "M8.118 8.533H40.83a.584.584 0 0 1 .584.584v3.5a.584.584 0 0 1-.584.584H8.118a.584.584 0 0 1-.584-.584v-3.5a.584.584 0 0 1 .584-.584z",
    className: "cls-1",
    "data-name": "Path 16969",
    transform: "translate(-7.534 -7.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16970",
    fill: "#e3e7f2",
    d: "M19.493 0h30.96a.584.584 0 0 1 .584.584v3.5a.584.584 0 0 1-.584.584h-30.96a.584.584 0 0 1-.584-.584v-3.5A.584.584 0 0 1 19.493 0z",
    "data-name": "Path 16970",
    transform: "translate(-18.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13690",
    "data-name": "Group 13690",
    transform: "translate(12.851 .584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10760",
    d: "M0 0H8.178V4.673H0z",
    className: "cls-4",
    "data-name": "Rectangle 10760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16971",
    d: "M210.81 76.8v3.5l-1.752-1.168L207.3 80.3l-1.752-1.168L203.8 80.3v-3.5z",
    className: "cls-4",
    "data-name": "Path 16971",
    transform: "translate(-203.216 -72.127)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    cx: 9.93,
    cy: 9.93,
    r: 9.93,
    fill: "url(#linear-gradient)",
    "data-name": "Ellipse 202",
    transform: "translate(7.01 11.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16972",
    fill: "#d4e1f4",
    d: "M165.93 205.142c1.216 2.464 4.071 2.2 5.314 1.955a.586.586 0 0 1 .685.541c.218 2.213.319 9.163-6.516 11.765-6.834-2.6-6.733-9.552-6.516-11.765a.586.586 0 0 1 .685-.541c1.242.248 4.1.509 5.314-1.955a.562.562 0 0 1 1.035 0z",
    "data-name": "Path 16972",
    transform: "translate(-148.472 -190.781)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16973",
    d: "M12.038 42.414h-1.753a1.172 1.172 0 0 1-1.168-1.168V13.207a.586.586 0 0 1-.584-.584v-3.5a.586.586 0 0 1 .584-.584h1.753a.586.586 0 0 0-.584.584v3.5a.586.586 0 0 0 .584.584v28.039a1.172 1.172 0 0 0 1.168 1.168z",
    className: "cls-7",
    "data-name": "Path 16973",
    transform: "translate(-7.949 -7.95)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16974",
    d: "M9.7 76.8v28.039H8.533V76.8z",
    className: "cls-7",
    "data-name": "Path 16974",
    transform: "translate(-7.949 -71.543)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13692",
    "data-name": "Group 13692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16975",
    d: "M9.172 137.7a.615.615 0 0 0 .415-.169.592.592 0 0 0 0-.829l-.088-.07a.445.445 0 0 0-.105-.053.372.372 0 0 0-.105-.035.854.854 0 0 0-.117-.012.613.613 0 0 0-.415.169.576.576 0 0 0 .193.952.582.582 0 0 0 .222.047z",
    className: "cls-8",
    "data-name": "Path 16975",
    transform: "translate(-8.004 -127.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16976",
    d: "M33.88 0H1.168A1.169 1.169 0 0 0 0 1.168v3.5a1.164 1.164 0 0 0 .584 1.011v1.915a.584.584 0 0 0 1.168 0V5.841h11.683v2.921c0 .018.009.034.011.052a.619.619 0 0 0 .068.223c.009.016.01.034.02.049s.028.025.039.039a.566.566 0 0 0 .084.084.539.539 0 0 0 .192.1.562.562 0 0 0 .115.023l.055.011c.019 0 .034-.009.052-.011a.62.62 0 0 0 .223-.068c.016-.009.034-.01.049-.02l1.429-.944 1.428.952a.585.585 0 0 0 .648 0l1.429-.952 1.428.952.122.057a.58.58 0 0 0 .2.041.584.584 0 0 0 .2-.041c.013 0 .026-.009.038-.015a.576.576 0 0 0 .161-.109l.025-.029a.572.572 0 0 0 .058-.067c.01-.015.011-.033.02-.049a.619.619 0 0 0 .068-.223c0-.018.011-.034.011-.052V5.841H33.3V33.3a.585.585 0 0 1-.584.584H2.337a.585.585 0 0 1-.584-.584V12.267a.584.584 0 0 0-1.168 0V33.3a1.754 1.754 0 0 0 1.752 1.752h30.375a1.754 1.754 0 0 0 1.752-1.752V5.679a1.164 1.164 0 0 0 .584-1.006v-3.5A1.169 1.169 0 0 0 33.88 0zM21.029 1.168v3.5h-7.01v-3.5h7.01zm-19.861 0h11.683v3.5H1.168zm19.277 6.5l-.845-.56a.585.585 0 0 0-.648 0l-1.428.952-1.424-.952a.585.585 0 0 0-.648 0l-.844.563v-1.83h5.841v1.83zm1.752-3v-3.5H33.88v3.5z",
    className: "cls-8",
    "data-name": "Path 16976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16977",
    d: "M123.429 164.115a10.514 10.514 0 1 0-10.515 10.515 10.515 10.515 0 0 0 10.515-10.515zm-19.861 0a9.346 9.346 0 1 1 9.346 9.346 9.346 9.346 0 0 1-9.346-9.346z",
    className: "cls-8",
    "data-name": "Path 16977",
    transform: "translate(-95.39 -143.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16978",
    d: "M158.7 212c7.249-2.76 7.106-10.165 6.889-12.368a1.209 1.209 0 0 0-.478-.854 1.135 1.135 0 0 0-.9-.2c-1.315.262-3.67.4-4.675-1.641a1.146 1.146 0 0 0-2.083 0c-1.005 2.039-3.361 1.9-4.675 1.641a1.147 1.147 0 0 0-.9.2 1.209 1.209 0 0 0-.478.854c-.217 2.2-.36 9.609 6.889 12.368a.584.584 0 0 0 .411 0zm-6.153-12.279c1.321.263 4.55.571 5.924-2.292a.075.075 0 0 1 .015.022c1.4 2.841 4.629 2.534 5.941 2.295.194 1.974.33 8.553-5.934 11.081-6.266-2.527-6.129-9.108-5.946-11.107z",
    className: "cls-8",
    "data-name": "Path 16978",
    transform: "translate(-140.968 -182.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16979",
    d: "M275.042 258.8a.584.584 0 0 0 .826-.826l-1.752-1.752a.584.584 0 0 0-.826.826z",
    className: "cls-8",
    "data-name": "Path 16979",
    transform: "translate(-254.426 -238.527)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16980",
    d: "M235.708 261.893a.584.584 0 0 0 .413-1l-4.673-4.673a.584.584 0 0 0-.826.826l4.673 4.673a.582.582 0 0 0 .413.174z",
    className: "cls-8",
    "data-name": "Path 16980",
    transform: "translate(-214.679 -238.527)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.2f8c5b76811e5ff11979c439f90656dc.svg";
export { ForwardRef as ReactComponent };